import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import EditIcon from "@mui/icons-material/Edit";

import PostAddIcon from "@mui/icons-material/PostAdd";

import Button from "../../../components/Button";
import { StyledSwitch } from "../../../components/Base";
import TableComponent from "../../../components/TableComponent";

import { getBundles, changeBundleStatus, changeBundleRefresher } from "../../../api/courseBundle";

const CourseBundle = ({ match, history }) => {
  const { t } = useTranslation();
  const [bundles, setBundles] = useState(null);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    (async () => {
      const res = await getBundles();
      setBundles(res);
    })();
  }, [refresh]);

  return (
    <>
      <Typography variant="h4">{t("course_bundle.title")}</Typography>
      {bundles ? (
        <TableComponent
          TopComponent={
            <Button size="small" onClick={() => history.push(`/bundles/add`)}>
              <PostAddIcon />
              {t("course_bundle.add_action")}
            </Button>
          }
          search={["displayname", "description"]}
          header={[
            { title: t("id"), style: { width: "5%" } },
            { title: t("name"), style: { width: "10%" } },
            { title: t("description"), style: { width: "10%" } },
            { title: t("price"), style: { width: "10%" } },
            { title: t("notes"), style: { width: "10%" } },
            { title: t("status"), style: { width: "10%" } },
            { title: t("course_bundle.refresher"), style: { width: "10%" } },
            { title: t("actions"), style: { width: "10%" } },
          ]}
          items={bundles}
          renderChildren={(bundle) => (
            <TableRow key={bundle.id}>
              <TableCell>{bundle.id}</TableCell>
              <TableCell>{bundle.displayname}</TableCell>
              <TableCell>{bundle.description}</TableCell>
              <TableCell>{bundle.price || t("free")}</TableCell>
              <TableCell>{bundle.validPeriod ? t("certificate.months", { count: bundle.validPeriod }) : ""}</TableCell>
              <TableCell>
                <StyledSwitch
                  title={t("course_bundle.active_toggle")}
                  checked={bundle.active}
                  onClick={async () => {
                    await changeBundleStatus(bundle.id, !bundle.active);
                    setRefresh(refresh + 1);
                  }}
                />
              </TableCell>
              <TableCell>
                <StyledSwitch
                  title={t("course_bundle.refresher_toggle")}
                  checked={bundle.isRefresher}
                  onClick={async () => {
                    await changeBundleRefresher(bundle.id, !bundle.isRefresher);
                    setRefresh(refresh + 1);
                  }}
                />
              </TableCell>
              <TableCell>
                <Button
                  icon={<EditIcon />}
                  onClick={() => history.push(`/bundles/edit/${bundle.id}`)}
                  title={t("course_bundle.edit_action")}
                />
              </TableCell>
            </TableRow>
          )}
        />
      ) : null}
    </>
  );
};

export default CourseBundle;
